<script>
import { ref } from 'vue'
import { Navigation } from 'swiper/modules'

export default {
  setup(props, { slots }) {
    const ready        = ref(false)
    const swipers      = ref(false)
    const setTheSwiper = (swiper) => {
      swipers.value = swiper
      ready.value   = true
    }

    return () => slots.default({
      ready: ready.value,
      modules: [Navigation],
      setTheSwiper
    })
  }
}
</script>